import { Tag } from '@cian/components';
import * as React from 'react';

import { ICoworkingIdTag } from '../../../state/tags/definitions/coworking_id';
import { TagNew } from '../TagNew';

import { tagThemeSmall } from '../tag_theme';

export interface ICoworkingIdTagProps {
  tag: ICoworkingIdTag;
  withNewTag?: boolean;
  onDeleteClick(): void;
}

export const CoworkingIdTag = (props: ICoworkingIdTagProps) => {
  const TagComponent = React.useMemo(() => (props.withNewTag ? TagNew : Tag), [props.withNewTag]);

  return (
    <TagComponent onDeleteClick={props.onDeleteClick} tagStyles={tagThemeSmall}>
      {props.tag.text}
    </TagComponent>
  );
};
